import React, { useContext, useEffect, useState } from 'react'
import fetchHook from '../../hooks/fetchMSSQL-hook'
import { NavigationContext } from '../../context/navigation-context'
import langContext, { LangContext } from '../../context/lang-context'
import formHook from '../../hooks/form-hook'
import NoResults from '../../components/NoResults/NoResults'
import { NotificationManager } from 'react-notifications'
import BagForm from '../../components/Modals/BagForm'
import SearchFilter from "../../components/Filter/SearchFilter"

export default function Bags() {
    const {fetchMssqlApi} = fetchHook()
    const { setHeaderData } = useContext(NavigationContext)
    const {form, openForm, closeForm} = formHook()
    const {TRL_Pack} = useContext(LangContext)
    const [bags, setBags] = useState([])

    const defaultFilter = {
        name: "bags",
        page: 1,
        isActive: "true",
        sortBy: "none",
    };

    const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({});

    const sortDefaults = {
        Name: "ASC",
        IsActive: "DESC",
    };

    const getSortState = () => {
        const [field, dir] = String(filter.sortBy || "").split("|");
        return { field, dir: (dir || "").toUpperCase() };
    };

    const sortState = getSortState();

    const arrow = (field) => {
        if (sortState.field !== field) return "";
        return sortState.dir === "ASC" ? " ▲" : " ▼";
    };

    const handleHeaderSort = (field) => {
        const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
        const curDir = (curDirRaw || "").toUpperCase();

        let nextDir;
        if (curField === field) {
            nextDir = curDir === "ASC" ? "DESC" : "ASC";
        } else {
            nextDir = sortDefaults[field] || "ASC";
        }

        const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
        setFilter(next);
        getBags(next);
    };

    const getCheckboxFromBool = (bool) => (
        <div className='d-flex justify-content-center align-items-center'>
            <input
                type='checkbox'
                checked={bool}
                onChange={() => {}}
            />
        </div>
    ) 

    const parseThreeState = (val) => {
        if (val === 'true') return true;
        if (val === 'false') return false;
        return null;
    };

    const getBags = (f) => {
        fetchMssqlApi(
            'bags',
            {
                method: "POST",
                hideNotification: true,
                data: {
                    isActive: parseThreeState(f?.isActive),
                    sortBy: f?.sortBy
                }
            },
            res => {
                setBags(res)
            }
        )
    }

    const handleSubmit = (evt, setData) => {
        evt.preventDefault()
        const {name, isActive} = evt.target.elements;
        
        const isAvaiable = bags.filter(bag => bag.BagId !== form).map(bag => bag.Name).indexOf(name.value) === -1
        const bag = bags.find(b => b.BagId === form)
        if (form !== "new" && String(bag.IsActive) !== isActive.value) {
            fetchMssqlApi(`bag`, {method:"PUT", data: {isActive: !bag.IsActive, name: bag.Name, bagId: form}}, () => {
                getBags(filter)
                closeForm()
            })
            return
        }
        if (!isAvaiable) {
            NotificationManager.error("Taka nazwa już istnieje")
            setData(prev => ({...prev, Name: ""}))
            return
        }
        if (form === "new") {
            fetchMssqlApi('bag', {method: "POST", data: {name: name.value}}, () => {
                getBags(filter)
                closeForm()
            })
        } else {
            fetchMssqlApi(`bag`, {method:"PUT", data: {isActive: !bag.IsActive, name: name.value, bagId: form}}, () => {
                getBags(filter)
                closeForm()
            })
        }
    }

    useEffect(() => {
        setHeaderData({text: "Worki na monety"})
    }, [])

    const rowsPerPage = settingsFilter?.rowsPerPage || 50;

    return (
        <div>
            <SearchFilter
                filterName="bags"
                defaultFilter={defaultFilter}
                onFilterChange={(f) => setFilter(prev => ({ ...prev, ...f }))}
                onSettingsChange={(s) => setSettingsFilter(prev => ({ ...prev, ...s }))}
                search={getBags}
                loading={false}
                totalCount={bags.slice(
                    (filter.page - 1) * rowsPerPage,
                    filter.page * rowsPerPage
                ).length}
                forNow
            />
            {bags.length ? (
                <div className='card'>
                <div className='card-header'>
                    
                <button
                    className="d-block btn text-nowrap btn-outline-secondary text-decoration-none ml-auto my-2 mr-1"
                    onClick={openForm()}
                >
                    <i className="fas fa-plus" />
                    {TRL_Pack.locations.addProductButton}
                </button>
            </div>
                <table className='table table-striped border' style={{width: "100%"}}>
                    <thead>
                        <tr className='headers-color'>
                            <th
                                className='text-center'
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("Name")}
                            >
                                Worek na monety{arrow("Name")}
                            </th>
                            <th
                                className='text-center'
                                style={{ cursor: "pointer", userSelect: "none" }}
                                onClick={() => handleHeaderSort("IsActive")}
                            >
                                Aktywny{arrow("IsActive")}
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {bags.slice(
                            (filter.page - 1) * rowsPerPage,
                            filter.page * rowsPerPage,
                            ).map((bag, idx) => (
                            <tr key={idx}>
                                <td className='text-center'>
                                    {bag.Name}
                                </td>
                                <td>
                                    {getCheckboxFromBool(bag.IsActive)}
                                </td>
                                <td className='d-flex justify-content-end mb-2 mt-2 border-0'>
                                    <button className="btn btn-outline-primary btn-sm "
                                        onClick={openForm(bag.BagId)}
                                    >
                                        Edytuj
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            ) : (
                <NoResults buttonText={TRL_Pack.locations.addProduct} onClick={openForm()} />
            )} 
            {
                form && 
                <BagForm
                    bagData={bags.find(bag => bag.BagId === form)}
                    handleClose={closeForm}
                    handleSubmit={handleSubmit} 
                />
            }
        </div>
    )
}